import React, { useContext } from 'react'
import { Link } from 'rebass'
import styles from './style.module.scss'

import WebsiteSvg from '@svgs/social-web.svg'
import FacebookSvg from '@svgs/social-facebook.svg'
import InstagramSvg from '@svgs/social-instagram.svg'
import TwitterSvg from '@svgs/social-twitter.svg'

import XText from 'v2/components/XText'
import XIcon from 'v2/components/XIcon'
import XColors from 'v2/styles/colors'
import { XTEXT_SIZE, XTEXT_DECORATIONS } from 'v2/styles/constants'
import { OrganizationContext } from 'v2/context/organization'
import { useTranslation } from 'i18n'
import XLanguageSwitcher from 'v2/components/XLanguageSwitcher'
import { isMobile } from 'react-device-detect'

interface Props {
    isLanguageSwitcher?: boolean
}

const XFooter = (props: Props) => {
    const { isLanguageSwitcher } = props

    const organizationContext = useContext(OrganizationContext)
    const { t } = useTranslation(window.LANG_NS)

    return (
        <footer className={styles.footer}>
            <div className={styles.footer__icon_container}>
                {!isMobile && isLanguageSwitcher && (
                    <div className={styles.footer__language_switcher_container}>
                        <XLanguageSwitcher />
                    </div>
                )}
                {organizationContext.program?.urlFragment && (
                    <Link target="__blank" href={organizationContext.organizationConfigs?.websiteLink} height={20}>
                        <XIcon icon={WebsiteSvg} size={20} tintColor={XColors.primaryColor} />
                    </Link>
                )}
                {organizationContext.organizationConfigs?.facebookLink && (
                    <Link target="__blank" href={organizationContext.organizationConfigs.facebookLink} height={20}>
                        <XIcon icon={FacebookSvg} size={14} tintColor={XColors.primaryColor} />
                    </Link>
                )}
                {organizationContext.organizationConfigs?.twitterLink && (
                    <Link target="__blank" href={organizationContext.organizationConfigs.twitterLink} height={20}>
                        <XIcon icon={TwitterSvg} size={14} tintColor={XColors.primaryColor} />
                    </Link>
                )}
                {organizationContext.organizationConfigs?.instagramLink && (
                    <Link target="__blank" href={organizationContext.organizationConfigs.instagramLink} height={20}>
                        <XIcon icon={InstagramSvg} size={14} tintColor={XColors.primaryColor} />
                    </Link>
                )}
            </div>
            <div
                className={
                    !isLanguageSwitcher
                        ? styles.footer__text_container_no_language_switcher
                        : styles.footer__text_container_language_switcher
                }
            >
                <XText size={XTEXT_SIZE.SMALL} decorator={XTEXT_DECORATIONS.BOLD} color={XColors.primaryColor}>
                    {t('side_bar_bottom_copyright')}
                </XText>
                <XText size={XTEXT_SIZE.SMALL} color={XColors.primaryColor}>
                    {t('side_bar_bottom_f4gi_description')}
                </XText>
            </div>
            {isMobile && isLanguageSwitcher && (
                <div className={styles.footer__language_switcher_container}>
                    <XLanguageSwitcher />
                </div>
            )}
        </footer>
    )
}

XFooter.displayName = 'Footer'

export default XFooter
